import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}payroll-component-entries`;

export default {
  list(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },
  createBulk(payload) {
    return axios.post(`${API_URL}/bulk`, payload, { headers: buildHeaders() });
  },
  update(id, payload) {
    return axios.put(`${API_URL}/${id}`, payload, { headers: buildHeaders() });
  },
  remove(id) {
    return axios.delete(`${API_URL}/${id}`, { headers: buildHeaders() });
  },
  removeBulk(ids = []) {
    return axios.post(
      `${API_URL}/bulk-delete`,
      { ids },
      { headers: buildHeaders() },
    );
  },
};
